<template>
    <div class="editor">
        <editor-menu-bar v-if="false" :editor="editor" v-slot="{ commands }">
            <div class="menubar">
                <button
                        class="menubar__button"
                        @click="showImagePrompt(commands.image)"
                >
                    <span class="i i-photo"></span>
                </button>
            </div>
        </editor-menu-bar>

        <editor-content class="inp" :editor="editor" />
    </div>
</template>


<script>
    import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
    import {
        HardBreak,
        Heading,
        Image,
        Bold,
        Code,
        Italic,
        Placeholder,
        History,
    } from 'tiptap-extensions'

    export default {
        name: "TextEditorNew",
        props: {
            content: {
                default: ''
            }
        },
        components: {
            EditorContent,
            EditorMenuBar,
        },
        mounted(){
            setTimeout(() => {
                if(this.content){
                    this.editor.setContent('<p>'+this.content.replace(/(?:\r\n|\r|\n)/g, '<br />')+'<p>')
                }
            }, 50);
        },
        data() {
            return {
                editor: new Editor({
                    extensions: [
                        new HardBreak(),
                        new Heading({ levels: [1, 2, 3] }),
                        new Image(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new History(),
                        new Placeholder({
                            emptyEditorClass: 'is-editor-empty',
                            emptyNodeClass: 'is-empty',
                            emptyNodeText: 'Подробно опишите правило',
                            showOnlyWhenEditable: true,
                            showOnlyCurrent: true,
                        }),
                    ],
                    autoFocus: true,
                    onUpdate: ({ getJSON, getHTML }) => {
                        // getJSON(), getHTML()
                        this.$emit('input',getHTML())
                    },
                    onFocus: () => {
                        this.$emit('focus');
                    },
                    onBlur: () => {
                        this.$emit('blur');
                    },
                }),
            }
        },
        methods: {
            showImagePrompt(command) {
                const src = prompt('Enter the url of your image here')
                if (src !== null) {
                    command({ src })
                }
            },
            setInitialContent (content) {

                //this.unwatch()
            }
        },
    }
</script>

<style>
    .editor p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        pointer-events: none;
        height: 0;
        font-size: 14px;
        line-height: 17px;
        opacity: 0.5;
        float: left;
    }
    .editor .ProseMirror :first-child {
        margin-top: 0;
    }
    .editor .ProseMirror * {
        font-size: 16px !important;
        line-height: 20px !important;
    }
    .editor .ProseMirror{
        min-height: 266px;
    }
    .error .editor .ProseMirror {
        color: #FF0006 !important;
    }
</style>
